module.exports = __webpack_public_path__ + "img/stax.8c2e37bc.jpg";